export default __webpack_public_path__ + "img/paper-clip.d1c9889a.png";